import { InjectionToken } from '@angular/core';

export const MORE_DETAIL_POPUP_DATA = new InjectionToken<any>('MORE_DETAIL_POPUP_DATA');
